import React, { Fragment, useState, useRef, useCallback } from 'react';
import Grid from '@mui/material/Grid';
import { Typography, Button, IconButton, Fab } from '@mui/material';
import moment from 'moment-timezone';
import MyResizeObserver from '../../../components/MyResizeObserver/MyResizeObserver';
import CreateIcon from '@mui/icons-material/Create';

const PolicyReviewHeading = props => {
  const { className, name, title, remarkOnClick, remarkDisabled, template, autoAdjustLayout, ...rest } = props;

  const [isRowLayout, setIsRowLayout] = useState(true);
  const containerRef = useRef(null);
  const resizeTimeoutRef = useRef(null);
  const dateStr = moment().format('DD-MMM-YYYY');

  // Debounced resize handler to prevent flickering
  const onResize = useCallback(() => {
    if (!autoAdjustLayout) return;

    // Clear any existing timeout
    if (resizeTimeoutRef.current) {
      clearTimeout(resizeTimeoutRef.current);
    }

    // Set a new timeout to delay the layout calculation
    resizeTimeoutRef.current = setTimeout(() => {
      const containerElem = containerRef.current;
      if (!containerElem) return;

      const titleElem = containerElem.querySelector('.policy-review-heading-title');
      if (!titleElem) return;

      const nameElem = containerElem.querySelector('.policy-review-heading-name');
      const dateElem = containerElem.querySelector('.policy-review-heading-date');

      const { offsetWidth: containerWidth, offsetHeight: containerHeight } = containerElem;
      const { offsetWidth: titleWidth, offsetHeight: titleHeight } = titleElem;
      const { offsetWidth: nameWidth } = nameElem || {};
      const { offsetWidth: dateWidth } = dateElem || {};

      // Add a buffer to prevent flickering at boundary sizes
      const buffer = 20; // pixels of buffer to prevent flickering

      if (isRowLayout) {
        // Only switch to column if we're significantly over the limit
        if (titleWidth >= containerWidth - buffer || titleHeight !== containerHeight) {
          setIsRowLayout(false);
        }
      } else {
        // Only switch to row if we have enough space with buffer
        const halfWidth = (containerWidth - titleWidth) / 2;
        if (titleWidth + (nameWidth || halfWidth) + (dateWidth || halfWidth) <= containerWidth - buffer) {
          setIsRowLayout(true);
        }
      }
    }, 100); // 100ms debounce
  }, [autoAdjustLayout, isRowLayout]);

  return (
    <Fragment>
      {autoAdjustLayout && <MyResizeObserver targetsSelector=".policy-review-heading-title" onResize={onResize} />}
      <Grid
        className={`policy-review-heading${className ? ` ${className}` : ''}`}
        {...rest}
        container
        ref={containerRef}
        sx={[{
          flexDirection: isRowLayout ? 'row' : 'column',
          justifyContent: isRowLayout ? 'space-between' : 'center',
          alignItems: "center"
        }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
        <Grid style={!isRowLayout ? { width: '100%' } : undefined}>
          <Grid
            container
            sx={{
              justifyContent: "space-between",
              alignItems: "center"
            }}>
            <Grid>
              <Typography className="policy-review-heading-name" style={{ fontSize: 20 }}>
                {name}
              </Typography>
            </Grid>
            {!isRowLayout && (
              <Grid>
                <Typography className="policy-review-heading-date">{dateStr}</Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid className="policy-review-heading-title" style={{ textAlign: 'center', padding: 16, display: 'flex', alignItems: "center" }}>
          {title}
          {!template && !!title && (
            <Fab
              color="primary"
              size="small"
              variant="circular"
              disabled={remarkDisabled}
              onClick={remarkOnClick}
              style={{marginLeft: 8}}
            >
              <CreateIcon style={{ color: "white" }} />
            </Fab>
          )}
        </Grid>
        {isRowLayout && (
          <Grid>
            <Typography className="policy-review-heading-date">{dateStr}</Typography>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

export default PolicyReviewHeading;
